<template>
    <div class="website">
        <div class="container">
            <div class="columns">
                <div class="column">
                    <template v-if="website && website.video_trailer && website.video_trailer.url">
                        <div class="website__top">
                            <div class="website__top-item website__top-item--trailer">
                                <video 
                                    width="676" 
                                    autoplay
                                    muted
                                    playsinline="true"
                                    webkit-playsinline="true"
                                    ref="trailer"
                                    class="website__trailer"
                                    :poster="website.video_trailer.image && website.video_trailer.image.url"
                                >
                                    <source :src="website.video_trailer.url" type="video/mp4">
                                </video>
                                <div class="website__trailer-icons">
                                    <i v-if="mute && isPlay" @click="muteOff" class="website__trailer-icon website__trailer-mute"><font-awesome-icon :style="{color: 'white'}" :icon="['fas', 'volume-xmark']" size="lg"/></i>
                                    <i v-if="!mute && isPlay" @click="muteOn" class="website__trailer-icon website__trailer-volume"><font-awesome-icon :style="{color: 'white'}" :icon="['fas', 'volume-low']" size="lg"/></i>
                                    <i v-if="!isPlay" @click="playAgain" class="website__trailer-icon website__trailer-play"><font-awesome-icon :style="{color: 'white'}" :icon="['fas', 'play']" size="lg"/></i>
                                    <i v-if="isPlay" @click="openFullScreen" class="website__trailer-icon website__trailer-expand"><font-awesome-icon :style="{color: 'white'}" :icon="['fas', 'expand']" size="lg"/></i>
                                </div>
                                <Labels v-if="website.label && website.label.length" :labels="website.label" :id="pageId"></Labels>
                            </div>
                            
                            <div class="website__info">
                                <h2 class="website__title">
                                    <IconSpeaker class="website__speaker" @click="speechSynthesis(website.title)"></IconSpeaker>
                                    {{website.title}} 
                                </h2>
                                <p class="website__lead" v-html="website.lead"></p>
                                <div class="website__target-age" v-if="targetAge">
                                    <IconI></IconI> Sugerowana grupa wiekowa: <span>{{ targetAge }}</span>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <div class="website__top" v-if="firstElement">
                            <router-link
                                :to="{
                                    name: 'Video',
                                    params: { type: firstElement.type, id: firstElement._id, slug: getSlug(firstElement.url), itemsPage: itemsPage, from: website.title },
                                }"
                                class="website__top-item"
                            >
                                <figure class="website__cover">
                                    <Image :image="firstElement.image" :width="676" :height="380" :isLazy="false"></Image>
                                    <IconPlay class="website__play" v-if="firstElement && firstElement.image"></IconPlay>
                                    <IconPlayHover class="website__play website__play--hover" v-if="firstElement && firstElement.image"></IconPlayHover>
                                    <Labels v-if="firstElement.label && firstElement.label.length" :labels="firstElement.label" :id="firstElement._id"></Labels>
                                </figure>
                            </router-link>
                            
                            <div class="website__info">
                                <h2 class="website__title">
                                    <IconSpeaker class="website__speaker" @click="speechSynthesis(firstElement.title)"></IconSpeaker>
                                    {{firstElement.title}} 
                                </h2>
                                <p class="website__lead" v-html="website.lead"></p>
                                <div class="website__target-age" v-if="targetAge">
                                    <IconI></IconI> Sugerowana grupa wiekowa: <span>{{ targetAge }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>

            <div class="website__items">
                <div class="columns is-multiline is-mobile">
                    <div class="column is-3-desktop is-6-tablet is-12-mobile website__element" :class="{'active': index === 0 && (!(website.video_trailer && website.video_trailer.url))}" :style="{ 'border-color': breadcrumbs && breadcrumbs.color }" v-for="(item, index) in videoList.items" :key="item._id">
                        <router-link
                            :to="{
                                name: 'Video',
                                params: { type: item.type.toUpperCase(), id: item._id, slug: getSlug(item.url), itemsPage: itemsPage, from: website.title },
                            }"
                            class="website__item"
                        >
                            <div class="website__item-cover">
                                <Image :image="item.image" :width="324" :height="182"></Image>
                                <Labels v-if="item.label" :labels="item.label" :id="item._id"></Labels>
                            </div>

                            <h2 class="website__item-title">{{ item.title }}</h2>
                        </router-link>
                    </div>
                </div>
            </div>

            <Pagination 
                v-if="videoList.total_count > itemsPerPage"
                :type="pageType"
                :name="name"
                :id="pageId"
                :itemsPage="itemsPage"
                :itemsPerPage="itemsPerPage" 
                :itemsTotalCount="videoList.total_count">
            </Pagination>
        </div>

        <transition name="fade" appear>
            <ModalUnlock 
                v-if="isModalUnlock" 
                :itemId="pageId" 
                :path="path"
                @closeModalUnlock="closeModalUnlock">
            </ModalUnlock>
        </transition>
    </div>
</template>

<script>
import axios from "axios";
import Image from "../elements/Image.vue";
import IconSpeaker from "../elements/icons/IconSpeaker.vue";
import IconPlay from "../elements/icons/IconPlay.vue";
import IconPlayHover from "../elements/icons/IconPlayHover.vue";
import IconI from "../elements/icons/IconI.vue";
import Pagination from "../elements/Pagination.vue";
import Labels from "../elements/Labels.vue";
import ModalUnlock from "../modals/ModalUnlock.vue";

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icons */
import { faVolumeXmark } from '@fortawesome/free-solid-svg-icons'
import { faVolumeLow } from '@fortawesome/free-solid-svg-icons'
import { faExpand } from '@fortawesome/free-solid-svg-icons'
import { faPlay } from '@fortawesome/free-solid-svg-icons'

/* add icons to the library */
library.add(faVolumeXmark);
library.add(faVolumeLow);
library.add(faExpand);
library.add(faPlay);

export default {
    name: "WebsiteDetail",
    components: {
        Image,
        IconSpeaker,
        IconPlay,
        IconPlayHover,
        Pagination,
        IconI,
        Labels,
        FontAwesomeIcon,
        ModalUnlock
    },
    props: {
        website: {
            type: Object,
            require: true,
        },
        pageType: {
            type: String
        },
        pageId: {
            type: Number
        }
    },
    data() {
        return {
            VIDEO_LIST: '/api/krainaabc/video/list?device=www&sort=position,1&id=',
            videoList: [],
            itemsPerPage: 12,
            mute: true,
            isPlay: false,
            isModalUnlock: false
        };
    },
    watch: {
        itemsPage() {
            this.getVideoList();
        },
        isAgePrevent(newValue) {
            if(newValue) {
                this.isModalUnlock = true;
                this.$store.dispatch("changeModalBackdrop", true);
            } else {
                this.isModalUnlock = false;
                this.$store.dispatch("changeModalBackdrop", false);
            }
        }
    },
    computed: {
        breadcrumbs() {
            if(
                this.website && 
                this.website.breadcrumbs && 
                this.website.breadcrumbs[0] && 
                this.website.breadcrumbs[0].title
            ) {
                return this.website.breadcrumbs[0];
            }
            return null;
        }, 
        firstElement() {
            if(
                this.website && 
                this.website.current_video 
            ) {
                return this.website.current_video;
            }
            return null;
        },
        itemsPage() {
            if(this.$route.query.page) {
                return parseInt(this.$route.query.page);
            }
            return 1;
        },
        name() {
            if(this.$route && this.$route.name) {
                return this.$route.name
            }
            return null;
        },
        isLogged() {
            return this.$store.getters.isLoggedIn;
        },
        targetAge() {
            if(this.isLogged) {
                if(this.website.target_age_three_six) {
                    return '3-10';
                } else if(this.website.target_age_seven_ten) {
                    return '7-10';
                } else {
                    return null;
                }
            }
            return null
        },
        isModalErrorOpen() {
            return this.$store.getters.getModalErrorOpen;
        },        
        getIsModalUnlock() {
            return this.$store.getters.getModalUnlock;
        },  
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        },
        activeSubProfile() {
            return this.$store.getters.getActiveSubProfile;
        },
        path() {
            return this.$route.fullPath;
        },
        isAgePrevent() {
            if(
                this.isLogged && 
                this.activeSubProfile && 
                this.activeSubProfile.age < 7 && 
                this.website.target_age_three_six === false &&
                this.website.target_age_seven_ten === true &&
                !this.checkIsFavorite(this.pageId)
            ) {
                return true;
            } 

            return false;
        }
    },
    methods: {
        getVideoList() {
            if(this.pageId) {
                let endpoint = `${this.VIDEO_LIST}${this.pageId}`;

                if(this.itemsPage) {
                    endpoint = endpoint + `&limit=${this.itemsPerPage}&page=${this.itemsPage}`;
                }

                axios.get(endpoint)
                    .then((response) => {
                        if (response.status === 200) {
                            if(response.data && response.data.data) {
                                this.videoList = response.data.data;
                            } else {
                                this.$store.dispatch("changeModalErrorOpenState");
                                this.$store.dispatch("changeModalBackdrop", true);                     
                            }
                        } else {
                            this.$store.dispatch("changeModalErrorOpenState");
                            this.$store.dispatch("changeModalBackdrop", true);     
                        }
                    })
                    .catch(() => {
                        // this.$store.dispatch("changeModalErrorLoadingState", true);
                        // this.$store.dispatch("changeModalBackdrop", true);  
                    });
            }
        },
        getSlug(url) {
            if(url) {
                return url.substring(url.lastIndexOf("/") + 1);
            }
        },
        muteOff() {
            this.$refs.trailer.muted = false;
            this.mute = false;
        },
        muteOn() {
            this.$refs.trailer.muted = true;
            this.mute = true;
        },
        playAgain() {
            this.$refs.trailer.play();
            this.play = true;
        },
        openFullScreen() {
            let trailer = this.$refs.trailer;

            if (trailer.requestFullscreen) {
                trailer.requestFullscreen();
            } else if (trailer.webkitEnterFullscreen) { /* Safari */
                trailer.webkitEnterFullscreen();    
            // } else if (trailer.webkitRequestFullscreen) { /* Safari */
            //     trailer.webkitRequestFullscreen();
            } else if (trailer.msRequestFullscreen) { /* IE11 */
                trailer.msRequestFullscreen();
            }
        },
        trailerEventsListener() {
            // console.log('trailerEventsListener');
            let trailer = this.$refs.trailer;

            if(trailer) {
                trailer.controls = false;
                // console.log('trailer');
                this.isPlay = true;
                // console.log('play');
                
                document.addEventListener("visibilitychange", () => {
                    if(document.hidden) {
                        trailer.pause();
                        // console.log('pause');
                    } else {
                        trailer.play();
                        // console.log('play');
                    }
                });

                let that = this;
                trailer.onended = function() {
                    // console.log('onended');
                    that.isPlay = false;
                };

                trailer.onplay = function() {
                    // console.log('onplay');
                    that.isPlay = true;
                };
            } else {
                // console.log('no trailer 2');
            }
        },
        closeModalUnlock(isReject) {
            this.isModalUnlock = false;
            this.$store.dispatch("changeModalBackdrop", false);
            if(isReject) {
                this.$router.push({
                    path: this.breadcrumbs.url.substring(this.breadcrumbs.url.lastIndexOf("/"))
                });   
            }
        },
        checkIsFavorite(id) {
            if(this.activeSubProfile && this.activeSubProfile.favorites && this.activeSubProfile.favorites.length && this.activeSubProfile.favorites.findIndex(el => el === id) !== -1) {
                return true;
            }
            return false;
        }
    },
    mounted() {
        this.getVideoList();

        setTimeout( ()=> {
            window.gemius_event(
                '_view_',
                this.gemiusIdentifier,
                `CATEGORY=${this.breadcrumbs && this.breadcrumbs.title}`
            ); 

            const interval = setInterval(() => {
                if (this.$refs.trailer) {
                    this.trailerEventsListener();
                    clearInterval(interval);
                } else {
                    if (!this.website.video_trailer) {
                        clearInterval(interval);
                    }
                }
            }, 50)
        }, 500);
    }
};
</script>